import React, { Component } from 'react';

class HeaderButton extends Component {
    render() {
        let className = "form-header-button " + this.props.type;
        if(this.props.selected) className = className + " selected";

        return (
            <button className={className} onClick={this.props.clickHandler}>
                <img className="form-header-icon" src={this.props.imgPath + this.props.type + "-icon.png"} alt={this.props.title} />
                <span className="form-header-text">{this.props.title}</span>
            </button>
        );
    }
}

HeaderButton.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default HeaderButton;


// WEBPACK FOOTER //
// ./src/components/HeaderButton.js